import liff from '@line/liff';
import * as React from 'react';
import { useRouter } from 'next/router';

import { LiffContext } from 'contexts/LiffContext';

interface Props {
  children: React.ReactNode;
}

export const LiffProvider = ({ children }: Props) => {
  const router = useRouter();
  const [initialized, setInitialized] = React.useState(false);

  React.useEffect(() => {
    if (
      router.asPath.match(/checkout/) ||
      router.asPath.match(/add/) ||
      router.asPath.match(/tickets/) ||
      router.asPath.match(/vauth/) ||
      router.asPath.match(/guidanceauth/) ||
      router.asPath.match(/reservationauth/) ||
      router.asPath.match(/reservations/) ||
      router.asPath.match(/guidance/) ||
      router.asPath.match(/surveyauth/) ||
      router.asPath.match(/survey/)
    ) {
      (async () => {
        await liff.init({ liffId: process.env.NEXT_PUBLIC_LIFF_ID ?? '' });
        setInitialized(true);
        if (!liff.isLoggedIn()) {
          liff.login({ redirectUri: window.location.href });
        }
      })();
    }
  }, [router.asPath]);

  return <LiffContext.Provider value={initialized ? liff : null}>{children}</LiffContext.Provider>;
};
